import { render, staticRenderFns } from "./HumanCapitalTop.vue?vue&type=template&id=a3952cfc&scoped=true&"
import script from "./HumanCapitalTop.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalTop.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalTop.vue?vue&type=style&index=0&id=a3952cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3952cfc",
  null
  
)

export default component.exports